"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InboxVisibleConversationStatuses = exports.ConversationStatus = void 0;
var ConversationStatus;
(function (ConversationStatus) {
  ConversationStatus["BULK_SENT"] = "BULK_SENT";
  ConversationStatus["OPEN"] = "OPEN";
  ConversationStatus["CLOSED"] = "CLOSED";
  ConversationStatus["PENDING"] = "PENDING";
  ConversationStatus["ARCHIVED"] = "ARCHIVED";
})(ConversationStatus = exports.ConversationStatus || (exports.ConversationStatus = {}));
exports.InboxVisibleConversationStatuses = [ConversationStatus.OPEN, ConversationStatus.PENDING, ConversationStatus.CLOSED];